import { render, staticRenderFns } from "./FAQsPage.vue?vue&type=template&id=299deca9&scoped=true"
import script from "./FAQsPage.vue?vue&type=script&lang=js"
export * from "./FAQsPage.vue?vue&type=script&lang=js"
import style0 from "./FAQsPage.vue?vue&type=style&index=0&id=299deca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299deca9",
  null
  
)

export default component.exports